import React from 'react'
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom'
import { ToastContainer } from 'react-toastify'
import { HashRouter } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'

import store from './store'
import api, { apiAction } from './api'
import { getTheme } from './themes.js'

const theme = getTheme()

document.title = theme.title

if (process.env.NODE_ENV !== 'production') {
  window.store = store
  window.apiAction = apiAction
  window.api = api
}

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <App />
    </HashRouter>
    <ToastContainer />
  </Provider>,
  document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
